import initializeComponent, { store } from '../react-initialize';
import PopupContainer from './popup_container';
import popupReducer from './reducer';
import * as actions from './actions';

store.injectReducer('popupState', popupReducer);

export { actions as PopupActions };

initializeComponent('PopupModal', PopupContainer);
